"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _areArraysEqual = require("./are-arrays-equal");
Object.keys(_areArraysEqual).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _areArraysEqual[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _areArraysEqual[key];
    }
  });
});